var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation',[_c('router-view')],1),(!_vm.$hasFeature('dispatch_order'))?_c('AgreementDialog'):_vm._e(),(_vm.$hasFeature('dispatch_order'))?_c('AgreementConfirmDialog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }